import http from './http';

export default {
  getCalendarList(id) {
    return http().get(`/v1/calendar_integration/${id}/calendars`);
  },
  setCalender(integrationId, calenderId, label) {
    return http().put(`/v1/calendar_integration/${integrationId}`, {
      calendar: calenderId,
      label: label
    });
  },
  // getEvents(id) {
  //   return http().get(`/v1/calendar_integration/oauth_url/${id}`);
  // },
  // createEvent(id) {
  //   return http().get(`/v1/calendar_integration/oauth_url/${id}`);
  // },
  // updateEvent(id) {
  //   return http().get(`/v1/calendar_integration/oauth_url/${id}`);
  // },
  // cancelEvent(id) {
  //   return http().get(`/v1/calendar_integration/oauth_url/${id}`);
  // },
}
